import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { BusinessType } from "shared/types";

type BusinessTypeProtectedRouteProps = {
  children: JSX.Element;
  allowedFor: BusinessType;
  redirectTo?: string;
};

export default function BusinessTypeProtectedRoute({
  children,
  allowedFor,
  redirectTo = "/subclient/account-management/accounts",
}: BusinessTypeProtectedRouteProps) {
  const { isTransferStationBusinessTypeEnabled } = useAuth();

  // If route is allowed for both business types, always allow access
  if (allowedFor === "both") {
    return children;
  }

  // Check if current business type matches the allowed type
  const isAllowed =
    (allowedFor === "transfer-station" &&
      isTransferStationBusinessTypeEnabled) ||
    (allowedFor === "hauling" && !isTransferStationBusinessTypeEnabled);

  // Redirect if access is not allowed
  if (!isAllowed) {
    return <Navigate to={redirectTo} replace />;
  }

  return children;
}
